import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { SiteProvider } from "@/lib/site";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import ScrollTop from "@/components/ScrollTop";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Portfolio from "@/pages/Portfolio";
import PortfolioDetail from "@/pages/PortfolioDetail";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import About from "@/pages/About";
import Team from "@/pages/Team";
import Pricing from "@/pages/Pricing";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";
import MobilePreview from "@/pages/MobilePreview";

import AdminLogin from "@/admin/Login";
import AdminApp from "@/admin/AdminApp";

function PublicLayout() {
  return (
    <div className="noise relative min-h-screen flex flex-col">
      <SmoothScroll />
      <ScrollTop />
      <div className="site-grid-overlay" data-testid="site-grid-overlay" aria-hidden="true" />
      <Navbar />
      <main className="flex-1 pt-16 md:pt-20">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

export default function App() {
  const wordpressBuild = process.env.REACT_APP_WORDPRESS_BUILD === "true";

  return (
    <BrowserRouter>
      <SiteProvider>
        <Routes>
          <Route path="/mobile-preview" element={<MobilePreview />} />
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/portfolio/:slug" element={<PortfolioDetail />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/category/:slug" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/team" element={<Team />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          {!wordpressBuild && <Route path="/admin/login" element={<AdminLogin />} />}
          {!wordpressBuild && <Route path="/admin/*" element={<AdminApp />} />}
        </Routes>
      </SiteProvider>
    </BrowserRouter>
  );
}
